"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var hooks_1 = require("preact/hooks");
var translations_1 = __importDefault(require("../../common/translations"));
var file_picker_1 = __importDefault(require("./file-picker"));
var button_1 = __importDefault(require("./button"));
var signals_1 = require("@preact/signals");
var StickyFilePicker = function (_a) {
    var onChange = _a.onChange, canvasRef = _a.canvasRef, loading = _a.loading;
    var isLoading = loading === true;
    var isVisible = (0, signals_1.useSignal)(false);
    var pickerRef = (0, hooks_1.useRef)(null);
    var openFilePicker = function () {
        var _a;
        (_a = pickerRef.current) === null || _a === void 0 ? void 0 : _a.openFilePicker();
    };
    (0, hooks_1.useEffect)(function () {
        var handleScroll = function () {
            if (canvasRef === null || canvasRef === void 0 ? void 0 : canvasRef.current) {
                var rect = canvasRef.current.getBoundingClientRect();
                // Check if the element is completely out of view (above the viewport)
                isVisible.value = rect.top + rect.height < 0;
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [canvasRef]);
    var classNames = (0, classnames_1.default)("fixed md:hidden md:static bottom-0 inset-x-0 w-full px-2 py-4 bg-white-darker border-t-2 border-gray-lighter z-50 flex items-center flex-col gap-4 transition-opacity", {
        "opacity-0 pointer-events-none": !isVisible.value,
        "opacity-100": isVisible.value,
    });
    return (0, jsx_runtime_1.jsxs)("div", __assign({ class: classNames }, { children: [(0, jsx_runtime_1.jsx)(file_picker_1.default, { loading: isLoading, onChange: onChange, ref: pickerRef }), (0, jsx_runtime_1.jsxs)("div", __assign({ class: "flex flex-col gap-4" }, { children: [isLoading && (0, jsx_runtime_1.jsx)("div", __assign({ class: "bg-white bg-opacity-50 w-full h-full flex flex-col justify-center items-center" }, { children: (0, jsx_runtime_1.jsx)("img", { class: "w-[60px] h-[60px] animate-spin duration-500", src: "/assets/images/spinner.svg", alt: "spinner" }) })), !isLoading && (0, jsx_runtime_1.jsx)(button_1.default, __assign({ class: "bg-purple hover:bg-purple-dark px-6 text-center font-bold z-10 shadow-md grow", onClick: openFilePicker }, { children: (0, translations_1.default)("cta") })), (0, jsx_runtime_1.jsxs)("div", __assign({ class: "flex flex-row gap-4 items-center justify-center px-4" }, { children: [(0, jsx_runtime_1.jsx)("img", { src: "/assets/images/icao-shield-icon.svg", alt: "ICAO Standard Icon", width: "35", height: "35" }), (0, jsx_runtime_1.jsx)("p", __assign({ class: "text-xs text-gray-darker" }, { children: (0, translations_1.default)("icaoNote") }))] }))] }))] }));
};
exports.default = StickyFilePicker;
